
export class NewMeasureMenu {
    private dropDownMeasureMenu: HTMLElement;
    private childDropDownItemMenu: HTMLElement;

    initialize() {

        this.dropDownMeasureMenu = document.getElementById("newMeasureMenuDropdown");

        // get all the menus which have sub-menus
        let dropDownItemMenu = document.querySelectorAll(".menu-new-measure .dropdown-item");
        dropDownItemMenu?.forEach(m => {
            m?.addEventListener('mouseover', this.showDropDownSubMenu);
            m?.addEventListener('mouseleave', this.hideDropDownSubMenu);
            m?.addEventListener('click', this.onClickSubMenuNewMeasure);
        });

        let dropDownChildMenu = document.querySelectorAll(".dropdown-menu.child-menu");
        dropDownChildMenu?.forEach(c => {
            c?.addEventListener('mouseleave', this.hideMenu);
        });

        let menuNewMeasureItem = document.querySelectorAll("a.menu-new-measure-item");
        menuNewMeasureItem?.forEach(i => {
            i?.addEventListener('click', this.hideParentMenu);
        });

        // Adjust dropdown's height on shwoing/hiding it
        $('#measureDropDownOuter').parent()?.on('shown.bs.dropdown', (ev: Event) => {
            this.checkDropDownHeight(this.dropDownMeasureMenu?.getBoundingClientRect());
        });
        $('#measureDropDownOuter').parent()?.on('hidden.bs.dropdown', (ev: Event) => {
            this.initializeDropDownHeight();
        });

    }

    // Hide the child dropdown 
    hideParentMenu = (ev: Event) => {
        (ev.target as HTMLElement).parentElement.classList.remove('show');
    }
    hideMenu = (ev: Event) => {
        (ev.target as HTMLElement).classList.remove('show');
    }

    // prevent event propagation
    onClickSubMenuNewMeasure = (ev: MouseEvent) => {
        ev.stopPropagation();
        this.childDropDownItemMenu = this.getChildElement(ev.target as HTMLElement);
        this.childDropDownItemMenu.classList.toggle('show');

        let rect = (ev.target as HTMLElement).getBoundingClientRect();
        this.childDropDownItemMenu.style.left = `${rect.right}px`;
        this.childDropDownItemMenu.style.top = `${rect.top}px`;
    }

    // show templates list by hover on menuName
    showDropDownSubMenu = (ev: MouseEvent) => {
        let rect = (ev.target as HTMLElement).getBoundingClientRect();
        this.childDropDownItemMenu = this.getChildElement(ev.target as HTMLElement);

        if (!this.childDropDownItemMenu.classList.contains('show')) {
            this.childDropDownItemMenu.classList.add('show');
            this.childDropDownItemMenu.style.left = `${rect.right}px`;
            this.childDropDownItemMenu.style.top = `${rect.top}px`;
        }
    }

    // hide templates list when mouse leave menuName
    hideDropDownSubMenu = (ev: MouseEvent) => {
        let parentElement = ev.target as HTMLElement;
        let relatedTarget = ev.relatedTarget as HTMLElement;
        this.childDropDownItemMenu = this.getChildElement(parentElement);
        if (relatedTarget.parentElement && !relatedTarget.parentElement.classList.contains('child-menu'))
            this.childDropDownItemMenu.classList.remove('show');
    }

    // set height value to empty
    initializeDropDownHeight = () => {
        this.dropDownMeasureMenu.style.height = "";
        this.dropDownMeasureMenu.classList.remove("overflow-auto");
    }

    // set new height values when list is long
    checkDropDownHeight = (size: any) => {
        if ((size.top + size.height) > window.innerHeight) {
            this.dropDownMeasureMenu.style.height = (window.innerHeight - size.top - 10) + "px";
            this.dropDownMeasureMenu.classList.add("overflow-auto");
        }
        else {
            this.initializeDropDownHeight();
        }
    }

    getChildElement = (elem: HTMLElement): HTMLElement => {
        return (document.getElementById(elem.getAttribute("data-path")));
    }
}